<script>
  import { fade } from "svelte/transition";
  import "../../../node_modules/croppie/croppie.css";
  import Croppie from "croppie";

  import { redirect } from "../../pager";
  import Alert from "../../components/Alert.svelte";
  import Title from "../../components/Title.svelte";
  import Navigationbar from "../../components/Navigationbar.svelte";
  import FileInput from "../../components/FileInput/FileInput.svelte";
  import Select from "svelte-select";

  //liblary
  import axios from "axios";

  import { session } from "../../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }
  //alert
  let alert = [];

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }

  //FORM ADD STORE

  let lat = "-6.6894830820344895";
  let long = "106.87940311589048";

  $: image1source = false;
  let area = { kode: undefined };
  let require;
  $: require = {
    id: undefined,
    image1: false,
    deskripsi: "",
    tokoalamat: "",
    tokolat: "",
    tokolong: "",
    telp: "",
  };

  let number;
  $: number = {
    telp: require.telp,
  };
  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  async function handleSubmit(event) {
    let valid = validator();
    if (valid) {
      axios
        .post(settings.url + "/sipade/toko?authorization=" + settings.token, {
          id: require.id,
          description: require.deskripsi,
          area: area.kode,
          avatar: require.image1,
          address_name: require.tokoalamat,
          lat: require.tokolat,
          long: require.tokolong,
          telp: require.telp,
        })
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: response.data.message,
              color: "green",
            },
          ];

          setTimeout(() => {
            redirect("/belanja/" + response.data.shop);
          }, 3000);
        })
        .catch(function (error) {
          backStep();

          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        });
    } else {
      console.error("belum terisi dengan benar");

      alert = [
        {
          title: "Dekatan",
          message: "Ada kolom yang belum Terisi dengan benar",
          color: "orange",
        },
      ];
    }
  }

  const toDataURL = (url) =>
    fetch(url, { mode: "no-cors" })
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  let items = [];
  let placeholder_area;
  axios
    .get(settings.url + "/sipade/toko", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      placeholder_area =
        response.data.area.desa +
        " " +
        response.data.area.kec +
        " " +
        response.data.area.kab;
      require = {
        id: items.data.ID,
        deskripsi: items.data.description,
        tokoalamat: items.data.address_name,
        telp: items.data.address_phone,
        tokolat: items.data.latitude,
        tokolong: items.data.longtitude,
      };

      area = {
        desa: items.area.desa,
        kec: items.area.kec,
        kab: items.area.kab,
        prov: items.area.prov,
        kode: items.area.kode,
      };

      addMapPicker();
      if (response.data.data.avatar) {
        toDataURL(
          "https://pics.dekatan.com/shop/" + response.data.data.avatar
        ).then((dataUrl) => {
          require.image1 = dataUrl;
          image1source = dataUrl;
          SetImage();
        });
      }
    });

  function SetImage() {
    if (require.image1) {
      document.getElementById("imgTumb1").innerHTML =
        '<img alt="logo" class="object-contain rounded-lg" src="' +
        require.image1 +
        '">';
      document.getElementById("image-blank-1").style.display = "none";
      document.getElementById("image-fill-1").style.display = "block";
    } else {
      document.getElementById("imgTumb1").innerHTML = " ";
      document.getElementById("image-blank-1").style.display = "block";
      document.getElementById("image-fill-1").style.display = "none";
    }
    console.log("Set Image");
  }

  let cropCrop;
  let binaryData;
  $: binaryData;
  let orientation = 1;
  let cropEl = document.getElementById("imgCrop");

  let cropImage = "1";

  function destroyCrop() {
    if (!cropCrop) return;
    cropCrop.destroy();
    cropCrop = null;
  }

  function initCrop() {
    if (cropCrop) return;

    cropCrop = new Croppie(document.querySelector("#imgCrop"), {
      viewport: { width: 300, height: 300 },
      boundary: { width: "100%", height: "70vh" },
      showZoomer: true,
      enableOrientation: true,
    });
  }

  function handleFileSelect(file) {
    var f = file.detail.files[0]; // FileList object
    if (f) {
      if (/(jpe?g|png|gif)$/i.test(f.type)) {
        if (f.size > 10292969) {
          alert = [
            ...alert,
            {
              message: "File yang dapat diproses maks 300Kb",
              color: "orange",
            },
          ];
        } else {
          var reader = new FileReader();

          // Closure to capture the file information.
          reader.onload = (function (theFile) {
            return function (e) {
              binaryData = e.target.result;
              if (cropImage == "1") {
                image1source = binaryData;
              }

              document.getElementById("imgCropModal").style.display = "block";
              SetImage();
              cropEl = document.getElementById("imgCrop");

              cropEl.style.display = "block";
              document.getElementById("imgCropmenu").style.display = "block";
              initCrop();

              cropCrop.bind({ zoom: 0, url: binaryData });

              document.getElementById(
                "image-blank-" + cropImage
              ).style.display = "none";
              document.getElementById("image-fill-" + cropImage).style.display =
                "block";
            };
          })(f);
          reader.readAsDataURL(f);
        }
      } else {
        alert = [
          ...alert,
          {
            message: "File yang dapat diproses berupa .jpg,jpeg,png,gif",
            color: "orange",
          },
        ];
      }
    } else {
      alert = [
        ...alert,
        {
          message: "File tidak ditemukan",
          color: "orange",
        },
      ];
    }
  }
  function cropRotateR() {
    cropCrop.rotate(90);
  }
  function cropRotateL() {
    cropCrop.rotate(-90);
  }
  function cropFlipx() {
    orientation = orientation == 1 ? 2 : 1;
    cropCrop.bind({ zoom: 0, url: binaryData, orientation: orientation });
  }
  function cropFlipy() {
    orientation = orientation == 1 ? 4 : 1;
    cropCrop.bind({ zoom: 0, url: binaryData, orientation: orientation });
  }
  let cropRes;
  function cropResult() {
    cropCrop
      .result({
        type: "base64",
        format: "png",
        size: { width: 600, height: 600, quality: 1 },
      })
      .then(function (imgcroped) {
        cropRes = imgcroped;
        if (cropImage == "1") {
          require.image1 = cropRes;
        }
        SetImage();
        document.getElementById("imgCropModal").style.display = "none";

        destroyCrop();
      });
  }

  let cropDisplay = "block";
  let cropmenuDisplay = "flex";
  function cropClose() {
    cropEl.style.display = "none";
    document.getElementById("imgCropModal").style.display = "none";
    initCrop();
  }

  function cropCloseX() {
    cropEl.style.display = "none";
    document.getElementById("imgCropModal").style.display = "none";
    SetImage();
  }
  function cropOpen() {
    cropEl = document.getElementById("imgCrop");
    document.getElementById("imgCropmenu").style.display = "block";
    cropEl.style.display = "block";
    document.getElementById("imgCropModal").style.display = "block";
    initCrop();
    if (cropImage == "1") {
      cropCrop.bind({ zoom: 0, url: image1source });
    }
  }

  $: lengthDescriptionCount = require.deskripsi.length;
  $: lengthAlamatCount = require.tokoalamat.length;

  import Item from "../../components/select/Item.svelte";
  import loadOptions from "../../components/select/area.js";

  const optionIdentifier = "id";
  const getOptionLabel = (option) => option.desa;
  const getSelectionLabel = (option) =>
    option.desa + " " + option.kec + " " + option.kab;

  import "leaflet/dist/leaflet.css";

  let L = window.L;
  let div = "map";
  function validateLatLng(latitude, longtitude) {
    if (latitude == "" || longtitude == "") {
      alert = [
        ...alert,
        {
          title: "Dekatan",
          message: "Kordinat Masih Kosong",
          color: "orange",
        },
      ];
      return false;
    } else {
      if (isFinite(latitude) && Math.abs(latitude) <= 90) {
        if (isFinite(longtitude) && Math.abs(longtitude) <= 180) {
          return true;
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Kordinat Longtitude Tidak Valid",
              color: "orange",
            },
          ];
          return false;
        }
      } else {
        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: "Kordinat Latitude Tidak Valid",
            color: "orange",
          },
        ];
        return false;
      }
    }
  }
  function addMapPicker(setCenter) {
    if (validateLatLng(require.tokolat, require.tokolong)) {
      document.getElementById("contmap").innerHTML = "";
      document.getElementById("contmap").style.display = "block";
      document.getElementById("contmap").innerHTML =
        "<div id='map' style='width: 100%; height: 100%;'></div>";
      let mapCenter = [require.tokolat, require.tokolong];
      var map = L.map(div, { center: mapCenter, zoom: 15 });
      L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution:
          '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
        id: "PositionPicker",
        noWrap: true,
      }).addTo(map);
      var marker = L.marker(mapCenter, {
        draggable: true,
      }).addTo(map);
      marker.bindPopup("Geser Hingga Sesuai").openPopup();
      function updateMarker(lat, lng) {
        axios
          .get(
            "https://shipper.id/bos/geodata/json_map_area?latlng=" +
              lat +
              "," +
              lng
          )
          .then(function (response) {
            marker
              .bindPopup(response.data.geocode.formatted_address)
              .openPopup();
          })
          .catch(function (error) {
            marker.bindPopup("Geser Hingga Sesuai").openPopup();
          });
        return false;
      }

      marker.on("drag", function (e) {});
      marker.on("dragstart", function (e) {});
      marker.on("dragend", function (e) {
        require.tokolat = e.target._latlng.lat;
        require.tokolong = e.target._latlng.lng;
        map.panTo([e.target._latlng.lat, e.target._latlng.lng]);
        updateMarker(e.target._latlng.lat, e.target._latlng.lng);
      });
    }
  }

  function getLocation() {
    navigator.geolocation.getCurrentPosition(
      displayLocationInfo,
      handleLocationError,
      { maximumAge: 1500000, timeout: 0, enableHighAccuracy: true }
    );
  }
  function displayLocationInfo(position) {
    require.tokolat = position.coords.latitude;
    require.tokolong = position.coords.longitude;
    console.log(
      "display:" + position.coords.latitude + "," + position.coords.longitude
    );
    addMapPicker();
  }

  function handleLocationError(error) {
    switch (error.code) {
      case 3:
        // timeout was hit, meaning nothing's in the cache
        // let's provide a default location:
        displayLocationInfo({ coords: { longitude: long, latitude: lat } });

        // now let's make a non-cached request to get the actual position
        navigator.geolocation.getCurrentPosition(
          displayLocationInfo,
          handleLocationError
        );
        break;
      case 2:
        // ...
        break;
      case 1:
      // ...
    }
  }
  function displayLocationbySelect(lat, long) {
    require.tokolat = lat;
    require.tokolong = long;
    addMapPicker();
  }
  function handleSelect(selectedVal) {
    console.log(selectedVal);
    displayLocationbySelect(selectedVal.detail.lat, selectedVal.detail.lang);
  }
</script>

<svelte:head>
  <title>Kelola Toko - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

{#if items.data}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title={items.data.nameShop}
    filter="true"
    filtercustom="<span>Menu</span>"
  />
{:else}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Toko Anda"
    filter="true"
    filtercustom="<span>Menu</span>"
  />
{/if}

<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  {#if items}
    <div class="max-w-lg mx-auto rounded-lg">
      <div class="w-full mx-auto my-5 lg:my-0">
        <div class="w-full mx-auto mb-2">
          <div class="p-10 pt-5 bg-white rounded-md shadow-md">
            <form autocomplete="off" class="w-full" on:submit|preventDefault>
              <div id="stepcontID1" class="block stepcontID">
                <div class="w-full lg:w-auto">
                  <Title
                    subtitle="Pastikan Isian Kamu Akurat"
                    title="Perbaharui Detail Toko"
                    tipe="2"
                  />
                </div>

                <div
                  id="imgCropModal"
                  class="fixed bottom-0 left-0 z-50 w-full h-screen bg-gray-200"
                  style="display:none"
                >
                  <div id="imgCropmenu" class="hidden h-auto m-2">
                    <div
                      class="flex justify-between px-4 py-2 text-lg font-bold text-center border-b border-gray-400"
                    >
                      <span class="py-1 text-gray-700">Editor Gambar</span><span
                        class="p-1 cursor-pointer"
                        on:click={cropCloseX}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          ><path
                            d="M14 12l5.544-5.544c.584-.583.61-1.511.06-2.06-.549-.55-1.476-.523-2.06.06L12.002 10 6.456 4.456c-.583-.583-1.51-.61-2.06-.06-.55.549-.523 1.477.06 2.06L10.001 12l-5.545 5.544c-.583.583-.61 1.511-.06 2.06.55.55 1.477.523 2.06-.06L12.001 14l5.543 5.544c.584.583 1.511.61 2.06.06.55-.549.524-1.477-.06-2.06L14.002 12z"
                            fill="#6C727C"
                          /></svg
                        ></span
                      >
                    </div>
                    <div
                      id="imgCropmenuhide"
                      class="flex justify-center gap-1 my-2"
                    >
                      <button
                        class="p-2 text-white bg-green-600 rounded"
                        on:click={cropResult}
                        on:click={destroyCrop}
                        on:click={cropClose}>Simpan</button
                      >
                      <button
                        class="p-2 text-white bg-orange-600 rounded"
                        on:click={cropRotateR}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          ><path
                            d="M19 12c0 3.9-3.1 7-7 7-3.2 0-6-2.2-6.8-5.2-.1-.5.2-1.1.7-1.2.5-.1 1.1.2 1.2.7v.1C7.8 15.5 9.7 17 12 17c2.8 0 5-2.2 5-5s-2.2-5-5-5c-1.3 0-2.5.5-3.4 1.3l1.2 1.2c.2.2 0 .5-.2.5H5.7c-.2 0-.3-.1-.3-.3V5.8c0-.3.3-.4.5-.2l1.3 1.3C8.5 5.7 10.2 5 12 5c3.9 0 7 3.1 7 7z"
                            fill="#fff"
                          /></svg
                        ></button
                      >
                      <button
                        class="p-2 text-white bg-orange-600 rounded"
                        on:click={cropRotateL}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          ><path
                            d="M5 12c0 3.9 3.1 7 7 7 3.2 0 6-2.2 6.8-5.2.1-.5-.2-1.1-.7-1.2-.5-.1-1.1.2-1.2.7v.1c-.7 2.1-2.6 3.6-4.9 3.6-2.8 0-5-2.2-5-5s2.2-5 5-5c1.3 0 2.5.5 3.4 1.3l-1.2 1.2c-.2.2 0 .5.2.5h3.9c.2 0 .3-.1.3-.3V5.8c0-.3-.3-.4-.5-.2l-1.3 1.3C15.5 5.7 13.8 5 12 5c-3.9 0-7 3.1-7 7z"
                            fill="#fff"
                          /></svg
                        ></button
                      >
                      <button
                        class="p-2 text-white bg-orange-600 rounded"
                        on:click={cropFlipx}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          ><path
                            d="M10 5.2v13.1c0 .4-.4.7-.9.7H4.8c-.6 0-1.1-.5-.9-1L9.5 5.1c.1-.2.5-.1.5.1zm4.5-.1c-.1-.2-.5-.1-.5.1v13.1c0 .4.4.7.9.7h4.3c.6 0 1.1-.5.9-1L14.5 5.1zM12 3c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5zm0 4c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5zm0 5c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5zm0 5c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5z"
                            fill="#fff"
                          /></svg
                        ></button
                      >
                      <button
                        class="p-2 text-white bg-orange-600 rounded"
                        on:click={cropFlipy}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          ><path
                            d="M18.8 10H5.7c-.4 0-.7-.4-.7-.9V4.8c0-.6.5-1.1 1-.9l12.9 5.6c.2.1.1.5-.1.5zm.1 4.5c.2-.1.1-.5-.1-.5H5.7c-.4 0-.7.4-.7.9v4.3c0 .6.5 1.1 1 .9l12.9-5.6zM21 12c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5zm-4 0c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zm-5 0c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zm-5 0c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5z"
                            fill="#fff"
                          /></svg
                        ></button
                      >
                    </div>
                  </div>
                  <div id="imgCrop" class="h-auto" />
                </div>
                <div
                  class="relative flex items-center justify-center w-64 mx-auto my-5 overflow-hidden bg-gray-200 border-4 border-gray-300 border-dashed rounded-full"
                  style="height:16rem"
                >
                  <div
                    id="imgTumb1"
                    class="absolute top-0 left-0 w-full overflow-hidden"
                  />

                  <FileInput
                    let:dragging
                    multiple={true}
                    on:input={handleFileSelect}
                  >
                    <div
                      on:click={() => (cropImage = "1")}
                      on:drop={() => (cropImage = "1")}
                      class="absolute left-0 top-0 text-blue-900 w-full
                        shadow-lg tracking-wide cursor-pointer text-center {!dragging
                        ? 'font-normal text-xs'
                        : 'font-bold text-sm'}"
                      style="height:16rem"
                    >
                      <div
                        style="display:block;"
                        class="absolute w-full h-full pt-20 text-center cursor-pointer"
                        id="image-blank-1"
                      >
                        <svg
                          class="w-8 h-8 mx-auto"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          ><path
                            d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                          /></svg
                        >

                        <span
                          class="font-bold uppercase"
                          id="image1-labelwarning">Logo Toko</span
                        ><br />
                        {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                      </div>

                      <div
                        style="display:none; background:rgba(49, 53, 59, 0.68);"
                        class="absolute w-full h-full py-20 text-center text-white transition-all duration-300 ease-in-out transform rounded-lg opacity-100 lg:opacity-0 md:opacity-0 hover:opacity-100"
                        id="image-fill-1"
                      >
                        <div
                          class="absolute bottom-0 right-0 w-full mb-4 text-center"
                        >
                          <span
                            on:click|preventDefault={() => (cropImage = "1")}
                            on:click|preventDefault={cropOpen}
                            class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 28 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              class="inline"
                              ><rect
                                width="28"
                                height="28"
                                rx="4"
                                fill="#fff"
                              />
                              <path
                                d="M23 20H11c-1.7 0-3-1.3-3-3V5h2v12c0 .6.4 1 1 1h12v2z"
                                fill="#6C727C"
                              />
                              <path
                                d="M10 8H5v2h5V8zm8 3v5h2v-5c0-1.7-1.3-3-3-3h-5v2h5c.6 0 1 .4 1 1zm2 7h-2v5h2v-5z"
                                fill="#6C727C"
                              /></svg
                            ></span
                          >
                          <span
                            on:click|preventDefault={() =>
                              (require.image1 = "")}
                            on:click|preventDefault={SetImage}
                            class="z-10 inline-block p-1 bg-white rounded-md hover:bg-gray-300"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 28 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              class="inline"
                              ><rect
                                width="28"
                                height="28"
                                rx="4"
                                fill="#fff"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17 6h3c.55 0 1 .45 1 1v1H7V7c0-.55.45-1 1-1h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zm-7 17c-1.1 0-2-.9-2-2V9h12v12c0 1.1-.9 2-2 2h-8z"
                                fill="#6C727C"
                              /></svg
                            ></span
                          >
                        </div>
                        <svg
                          class="w-8 h-8 mx-auto"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          ><path
                            d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                          /></svg
                        >

                        <span class="uppercase">Ganti Gambar</span><br />
                        {!dragging ? "Klik Disini" : "Ok Lepaskan"}
                      </div>
                    </div>
                  </FileInput>
                </div>

                <section class="mt-5 paragraphs">
                  <label
                    for="deskripsi"
                    class="relative block text-sm font-light"
                  >
                    <textarea
                      placeholder="Jelaskan tentang toko ini secara singkat padat"
                      maxlength="200"
                      id="deskripsi"
                      class="w-full h-32 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded-lg form-textarea hover:border-blue-400 focus:shadow-none"
                      bind:value={require.deskripsi}
                    />
                    <span
                      class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                      id="deskripsi-warning"
                    />
                    <span
                      class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                      id="deskripsi-labelwarning"
                      >Tentang Toko
                      <span class="my-2 text-xs text-right text-gray-500"
                        >{lengthDescriptionCount}/200</span
                      ></span
                    >
                  </label>
                </section>

                <section class="mt-5">
                  <label for="area" class="relative block text-sm font-light">
                    <div
                      class="text-sm text-gray-800 placeholder-gray-400 themed"
                    >
                      <Select
                        on:select={handleSelect}
                        {loadOptions}
                        {optionIdentifier}
                        {getSelectionLabel}
                        {getOptionLabel}
                        {Item}
                        bind:selectedValue={area}
                        noOptionsMessage="Ketikan Nama Desa"
                        placeholder={placeholder_area}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="area-labelwarning">Lokasi Toko</span
                      >
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="area-warning"
                      />
                    </div>
                  </label>
                </section>

                <section class="mt-5 paragraphs">
                  <label
                    for="tokoalamat"
                    class="relative block text-sm font-light"
                  >
                    <textarea
                      placeholder="Jelaskan tentang toko ini secara singkat padat"
                      maxlength="200"
                      id="tokoalamat"
                      class="w-full h-24 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded-lg form-textarea hover:border-blue-400 focus:shadow-none"
                      bind:value={require.tokoalamat}
                    />
                    <span
                      class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                      id="tokoalamat-warning"
                    />
                    <span
                      class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                      id="tokoalamat-labelwarning"
                      >Alamat Lengkap
                      <span class="my-2 text-xs text-right text-gray-500"
                        >{lengthAlamatCount}/200</span
                      ></span
                    >
                  </label>
                </section>

                <section class="mt-5">
                  <label
                    for="tokolat"
                    class="relative block text-sm font-light"
                  >
                    <input
                      id="tokolat"
                      type="text"
                      class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                      placeholder="tokolatitude"
                      bind:value={require.tokolat}
                      on:change={addMapPicker}
                    />
                    <span
                      class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                      id="tokolat-labelwarning">latitude</span
                    >
                    <span
                      class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                      id="tokolat-warning"
                    />
                  </label>
                </section>

                <section class="mt-5">
                  <label
                    for="tokolong"
                    class="relative block text-sm font-light"
                  >
                    <input
                      id="tokolong"
                      type="text"
                      class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                      placeholder="tokolongtitude"
                      bind:value={require.tokolong}
                      on:change={addMapPicker}
                    />
                    <span
                      class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                      id="tokolong-labelwarning">Longtitude</span
                    >
                    <span
                      class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                      id="tokolong-warning"
                    />
                  </label>
                </section>

                <section>
                  <span
                    class="px-2 text-xs border rounded cursor-pointer focus:bg-gray-500 focus:outline-none"
                    on:click={addMapPicker}
                  >
                    Buka Peta
                  </span>
                  <span
                    class="px-2 text-xs border rounded cursor-pointer focus:bg-gray-500 focus:outline-none"
                    on:click={getLocation}
                  >
                    Ambil Posisi Saat Ini
                  </span>
                </section>

                <div
                  id="contmap"
                  class="sticky w-full my-1 overflow-hidden rounded"
                  style="display:none; height:250px;"
                >
                  <div id="map" style="width: 100%; height: 100%;" />
                </div>

                <section class="mt-5">
                  <label for="telp" class="relative block text-sm font-light">
                    <input
                      autocomplete="off"
                      minlength="10"
                      id="telp"
                      type="text"
                      name="telp"
                      class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                      placeholder="628*********"
                      bind:value={require.telp}
                    />
                    <span
                      class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                      id="telp-labelwarning"
                      >No. HP/WA <span class="text-xs"
                        >(tanpa awalan + atau 0)</span
                      ></span
                    >
                    <span
                      class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                      id="telp-warning"
                    />
                  </label>
                </section>

                <button
                  type="button"
                  class="w-auto px-5 py-2 my-5 text-gray-100 bg-green-600 rounded text-1xl focus:bg-gray-500 focus:outline-none"
                  on:click={loadingBtn}
                  on:click={handleSubmit}
                >
                  SIMPAN
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  {/if}
</main>

<style>
  .themed {
    --border: 1px solid #a0aec0;
    --borderRadius: 0.25rem;
    --placeholderColor: #e2e8f0;
    --background: #fff;
    --inputFontSize: 0.875rem;
    --borderHoverColor: #63b3ed;
    --borderFocusColor: #63b3ed;
    --placeholderColor: #adb9c8;
    --itemIsActiveBG: #63b3ed;
  }
</style>
